import React from 'react';
import { Alert } from 'react-bootstrap';
import { AppContainer } from 'react-hot-loader';

const ErrorBoundary = props => (
  <Alert bsStyle="danger">
    Apologies, we have encountered an unexpected error. Please try again and contact support if problem persists. <br />
    <br />
    <small>
      Technical Data follows:
      <pre>{JSON.stringify(props)}</pre>
    </small>
  </Alert>
);

const ErrorHandlingAppContainer = props => <AppContainer errorReporter={ErrorBoundary} {...props} />;

export default ErrorHandlingAppContainer;



// WEBPACK FOOTER //
// ./src/ErrorHandlingAppContainer.jsx